import { render } from "./TierConfirm.vue?vue&type=template&id=06763ed4"
import script from "./TierConfirm.vue?vue&type=script&lang=js"
export * from "./TierConfirm.vue?vue&type=script&lang=js"

import "./TierConfirm.vue?vue&type=style&index=0&id=06763ed4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__